<template>
  <aside :class="{ active: isActive, 'active-mobile': isActive }">
    <ul>
      <li @click="asideClose">
        <!-- < <a href="#" @click="modalShow"> #打開coming soon pop-up -->
        <a :href="'//starluxairlines.sharepoint.com/sites/cfdcloud'" target="_blank">
          <div class="icon">
            <img src="img/icon_shield.svg" />
          </div>
          <div class="text">SMS</div>
        </a>
      </li>
      <li @click="asideClose">
        <!-- <a :href="'//starluxairlines.asqs.net/'" target="_blank"> -->
        <a :href="'https://starluxairlines.asqs.net/'" target="_blank">
          <div class="icon">
            <img src="img/icon_iqsms.png" />
          </div>
          <div class="text">iQSMS</div>
        </a>
      </li>
      <li @click="asideClose">
        <a :href="'//starluxairlines.sharepoint.com/sites/EIP'" target="_blank">
          <div class="icon">
            <i class="icons icon-plane"></i>
          </div>
          <div class="text">STARLUX EIP</div>
        </a>
      </li>
      <li @click="asideClose">
        <a :href="'https://jxcrew.starlux-airlines.com/jxcrew/quals'" target="_blank">
          <div class="icon">
            <i class="fa fa-vcard-o"></i>
          </div>
          <div class="text">My Qualification</div>
        </a>
      </li>
      <!-- <li :class="{'active':asideClick==this.GLOBAL.pilotportal['cabincrewmmo_list']}">
          <a :href="'/#/newslist/'+this.GLOBAL.pilotportal['cabincrewmmo_list']">
            <div class="icon">
              <i class="icons icon-bell"></i>
            </div>
            <div class="text">Crew MMO</div>
          </a>
        </li> -->
      <li @click="asideClose">
        <a :href="'/#/d1folderlist/fleet notice'">
          <div class="icon">
            <img src="img/icon_fleet_notice.svg" alt="" />
          </div>
          <div class="text">Fleet Notice</div>
        </a>
      </li>
      <li @click="asideClose">
        <!-- <li :class="{'active':asideClick=='manual'}"> -->
        <a :href="'/#/StaticFolderList/manual'">
          <div class="icon">
            <img src="img/icon_library.svg" />
          </div>
          <div class="text">Manual</div>
        </a>
      </li>
      <li @click="asideClose">
        <a :href="'//etds.starlux-airlines.com/'" target="_blank">
          <div class="icon">
            <i class="icons icon-book-open"></i>
          </div>
          <div class="text">eTDS</div>
        </a>
      </li>
      <li @click="asideClose">
        <a href="#" @click="modalShow">
          <div class="icon">
            <img src="img/icon_pelesys.svg" />
          </div>
          <div class="text">PELESYS</div>
        </a>
      </li>
      <li @click="asideClose">
        <!-- <li :class="{'active':asideClick=='training material'}"> -->
        <a :href="'/#/StaticFolderList/training material'">
          <div class="icon">
            <i class="fa fa-book"></i>
          </div>
          <div class="text">Training Material</div>
        </a>
      </li>
      <li @click="asideClose">
        <!-- <li :class="{'active':asideClick=='supervisory pilots'}"> -->
        <a :href="'/#/StaticFolderList/supervisory pilots'">
          <div class="icon">
            <img src="img/icon_supervisory.svg" alt="" />
          </div>
          <div class="text">Supervisory Pilots</div>
        </a>
      </li>
      <li @click="asideClose">
        <!-- 先註解原路徑 -->
        <!-- <a
          :href="
            'https://starluxairlines.sharepoint.com/sites/EIP/Perm1/Forms/AllItems.aspx?as=json&FolderCTID=0x012000940E1699A4C8D94CA4428F219EFFC892&id=%2Fsites%2FEIP%2FPerm1%2F%E4%BA%A4%E9%80%9A%E8%B3%87%E8%A8%8A%2F%E5%85%AC%E5%8F%B8%E4%BA%A4%E9%80%9A%E8%BB%8A%E6%99%82%E5%88%BB%E8%A1%A8&viewid=7d10f130%2Df6bb%2D4c06%2Dbe26%2Df6405408389d&OR=Teams%2DHL&CT=1710812943075&clickparams=eyJBcHBOYW1lIjoiVGVhbXMtRGVza3RvcCIsIkFwcFZlcnNpb24iOiI1MC8yNDAyMDIwNTUxNiIsIkhhc0ZlZGVyYXRlZFVzZXIiOmZhbHNlfQ%3D%3D'
          "
          target="_blank"
        >
          <div class="icon">
            <img src="img/icon_transport.svg" />
          </div>
          <div class="text">Transport</div>
        </a> -->
        <router-link :to="{ name: 'TransPort' }" target="_blank">
          <div class="icon">
            <img src="img/icon_transport.svg" />
          </div>
          <div class="text">Transport</div>
        </router-link>
      </li>
      <li @click="asideClose">
        <a href="awagentenroll://">
          <div class="icon"><img src="img/icon_hub.svg" /></div>
          <div class="text">Pilot Apps</div>
        </a>
      </li>
      <li @click="asideClose">
        <!-- <li :class="{'active':asideClick=='pss'}"> -->
        <!-- <a :href="'/#/d1folderdetail/pss'"> -->
        <a :href="'/#/folderdetail/pss'">
          <div class="icon">
            <span class="fa-stack">
              <i class="fa fa-file-o fa-stack-1x"></i>
              <i class="fa fa-plane text-sm fa-stack-1x mt-5"></i>
            </span>
          </div>
          <div class="text">Schedule Info</div>
        </a>
      </li>
      <li @click="asideClose">
        <!-- <li :class="{'active':asideClick=='hotel'}"> -->
        <a :href="'/#/d1folderlist/hotel'">
          <div class="icon">
            <img src="img/icon_building.svg" />
          </div>
          <div class="text">Stay Hotel Info</div>
        </a>
      </li>
    </ul>
  </aside>
</template>

<script>
export default {
  props: ['active'],
  data: () => ({
    modalIsShow: true
  }),
  methods: {
    modalShow() {
      this.$emit('asideModal', true)
    },
    asideClose() {
      this.$emit('asideClose', this.active)
    },
    outsideAside() {
      document.addEventListener('click', e => {
        if (this.active === true) {
          if (!e.target.closest('aside') && !e.target.closest('.icon-menu')) {
            this.$emit('asideClose', this.active)
          }
        }
      })
    }
  },
  computed: {
    isActive() {
      return this.active
    },
    asideClick() {
      return this.$route.params.name
    }
  },
  mounted() {
    this.outsideAside()
  }
}
</script>
